import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
// import "../../../styles/analytics/report-modal.scss";
import DataGroupModal from "../data-group-modal.jsx";
import { getId } from "../../../../utils/analytics-utils.js";

const CustomAnalytics = ({ campaigns, setCampaigns }) => {
  const [dataGroupModal, setDataGroupModal] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [showCustomAnalytics, setShowCustomAnalytics] = useState(false);

  const handleRemove = (id) => {
    setCampaigns(campaigns.filter((x) => x.id !== id));
  };

  const handleEdit = (data) => {
    setSelectedCampaign(data);
    setDataGroupModal(true);
  };

  const addNewCampaign = () => {
    const campaign = {
      id: getId(),
      title: "",
      comments: "",
      results: [],
    };
    setCampaigns([...campaigns, campaign]);
    setSelectedCampaign(campaign);
    setDataGroupModal(true);
  };

  const handleSubmitEditing = (data) => {
    setCampaigns(
      campaigns.map((campaign) => {
        if (campaign.id === data.id) {
          return data;
        }
        return campaign;
      })
    );
    setDataGroupModal(false);
  };

  return (
    <Box>
      <Typography
        className="label"
        component="div"
        sx={{ cursor: "pointer" }}
        onClick={() => setShowCustomAnalytics(!showCustomAnalytics)}
      >
        Custom Analytics
        <i
          class={`fa ${
            showCustomAnalytics ? "fa-chevron-down" : "fa-chevron-right"
          }`}
          aria-hidden="true"
        ></i>
      </Typography>

      {showCustomAnalytics && (
        <Box className="custom-analytics">
          <table className="padded-table">
            <tbody>
              <tr>
                <th>Data Group Name</th>
                <th className="th-controls">Controls</th>
              </tr>
              {campaigns.map((campaign) => (
                <tr
                  ng-repeat="campaign in reportParameters.campaigns"
                  className="ng-scope"
                >
                  <td>
                    <Typography component="span" className="td-title">
                      {campaign.title}
                    </Typography>
                  </td>
                  <td className="td-controls">
                    <i
                      className="fa fa-lg fa-pencil clickable"
                      aria-hidden="true"
                      onClick={() => handleEdit(campaign)}
                    ></i>

                    <i
                      className="fa fa-lg fa-trash-o clickable sleek-hover"
                      aria-hidden="true"
                      onClick={() => handleRemove(campaign.id)}
                    ></i>
                  </td>
                </tr>
              ))}

              <tr className="tr-action">
                <td colspan="2">
                  <a
                    href=""
                    onClick={(e) => {
                      e.preventDefault();
                      addNewCampaign();
                    }}
                  >
                    <i className="fa fa-plus-circle" aria-hidden="true"></i>

                    <span>
                      {campaigns.length > 0
                        ? "Add Another Entry"
                        : "Add an Entry"}
                    </span>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>

          <DataGroupModal
            open={dataGroupModal}
            data={selectedCampaign}
            onClose={() => {
              setDataGroupModal(false);
              setSelectedCampaign(null);
            }}
            onSubmit={handleSubmitEditing}
          />
        </Box>
      )}
    </Box>
  );
};

export default CustomAnalytics;
